(($) => {
    /********************** featured_projects **********************/
    const image = $('.featured_projects--card__image > .responsive-image');
    const currentSlide = $('.featured_projects--arrows__current');

    image.each(function() {
        this.addEventListener('click', function(e) {
            const target = $(e.currentTarget);
            const windowWidth = $(window).width();
            const isSlickButton = $(e.target).hasClass('featured_projects--arrows__prev') || $(e.target).hasClass('featured_projects--arrows__next');
    
            if (windowWidth < 992 && isSlickButton) {
                return;
            } else {
                target.toggleClass('active');
            }
        }, { passive: true });
    });

    $('#featured_projects__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        draggable: true,
        autoplay: false,
        arrows: false,
        dots: false,
        appendDots: $('.featured_projects--dots'),
        addaptiveHeight: true,
    });

    function updateCurrentSlide() {
        const current = $('.slick-current').find('.featured_projects--card');
        currentSlide.text(current.data('project'));
    }

    $('.featured_projects--arrows__next').on('click', function() {
        $('#featured_projects__slider').slick('slickNext');
        updateCurrentSlide();
    });

    $('.featured_projects--arrows__prev').on('click', function() {
        $('#featured_projects__slider').slick('slickPrev');
        updateCurrentSlide();
    });

    $('#featured_projects__slider').on('swipe', function(event, slick, direction){
        updateCurrentSlide();
    });

    /*********************** Recent Projects **********************/
    const recentProjectsCards = $('.recent_projects--card');
    const recentProjectsShowMore = $('#recent_projects_showMore');
    const postsToShowText = $('.posts_to_show');
    const postsTotalText = $('.posts_count');
    const postCountLoadedBar = $('#post_count_loadedBar');
    const showMoreProjects = $('#recent_projects #recent_projects_showMore');
    const showPostCount = $('#recent_projects .post_count');
    
    let postsToShow = getInitialPostsToShow();
    let postsLoaded = postsToShow;
    
    function getInitialPostsToShow() {
        if (window.innerWidth <= 500) {
            return 2;
        } else if (window.innerWidth <= 992) {
            return 4;
        } else {
            showMoreProjects.css('display', 'none');
            showPostCount.css('display', 'none');
            return 6;
        }
    }
    
    function updateVisiblePosts() {
        recentProjectsCards.slice(0, postsLoaded).show('slow');
        updateLoadBar();
        updatePostCounts();
        hideShowMoreButtonIfNeeded();
    }
    
    function updateLoadBar() {
        const percentage = (recentProjectsCards.filter(':visible').length / recentProjectsCards.length) * 100;
        postCountLoadedBar.children('.loadBar').width(percentage + '%');
    }
    
    function updatePostCounts() {
        postsToShowText.text(recentProjectsCards.filter(':visible').length);
        postsTotalText.text(recentProjectsCards.length);
    }
    
    function hideShowMoreButtonIfNeeded() {
        if (recentProjectsCards.filter(':visible').length >= recentProjectsCards.length) {
            recentProjectsShowMore.hide();
        }
    }
    
    recentProjectsShowMore.on('click', () => {
        postsLoaded += postsToShow;
        updateVisiblePosts();
    });
    
    // Initial setup
    updateVisiblePosts();

    /*********************** usps **********************/
    if ($('#usps')) {
        const usps_section = $('#usps');
        const cards = $('.usp-card');
        const usps = $('.usps-text__body');

        usps_section.on('click', (e) => {
            cards.removeClass('active');
            $('.usps-text__body').hide();
            $(`.usps-text__body[data-usp="default"]`).show();
        });

        cards.on('click', (e) => {
            const target = $(e.currentTarget);
            target.toggleClass('active');

            if (target.hasClass('active')) {
                cards.not(target).removeClass('active');
            }

            usps.hide();
            // get the usp text with matching attribute
            $(`.usps-text__body[data-usp="${target.data('usp')}"]`).show();
            e.stopPropagation();       
        });
    }

    /********************** keyPoints ********************/
    if ($('#keyPoints__accordion')) {
        const keyPoints = $('.keyPoints__accordion-item');
        const keyPointsContent = $('.keyPoints__accordion-item-content');

        keyPoints.on('click', (e) => {
            const target = $(e.currentTarget);
            
            if (target.hasClass('active')) {
                target.removeClass('active');
                keyPointsContent.slideUp();
                return;
            } else {
                target.toggleClass('active');
                keyPoints.not(target).removeClass('active');
                keyPointsContent.slideUp();
                target.children('.keyPoints__accordion-item-content').slideDown();
                return;
            }
        });
    }

    /*********************** Bespoke Form **********************/
    if ($('#tpfl__interactrive_form')) {
        const form = $('#tpfl-bespokeForm');
        const formInputs = form.find('input, textarea');
        const formSteps = $('.tpfl-bespoke__field-group');
        const prevStep = $('.tpfl-bespoke__controls-back');
        const skipToForm = $('.tpfl-bespoke__controls-skip');
        const options = $('.option');
        const progressBar = $('.tpfl-if__progress-bar');
        let currentStep = 1;
        let data = {};

        function setProgressBar() {
            const percentage = (currentStep / formSteps.length) * 100;
            progressBar.children().animate({ width: percentage + '%' }, 1000); // 1000ms = 1 second
        }
        setProgressBar();

        function updateFormStep() {
            $(`.tpfl-bespoke__steps-step > .steps-completed`).text(currentStep);
        }   

        function buildMessage(data) {
            // check if data is empty
            let message = 'I am interested in the following: \n';
            const sections = $('.tpfl-bespoke__field-group[data-name]')
            sections.each((key, section) => {
                const target = $(section);
                const messageLabel = target.data('message') ? target.data('message') : (target.data('name') ? target.data('name') : '');
                const selectedValue = data && data[key + 1]?.value ? `${data[key + 1].value}\n` : '\n';
                if (messageLabel !== 'undefined' && messageLabel !== '') {
                    message += `${messageLabel}: ${selectedValue}`;
                }
            });
            formInputs.each((index, input) => {
                const target = $(input);
                if (target.attr('name') === '00NN1000001ysMj') {
                    target.val(message);
                }
            });
        }

        function nextStep() {
            currentStep += 1;
            formSteps.hide();
            $(`.tpfl-bespoke__field-group[data-step="${currentStep}"]`).show();
            updateFormStep();
            if (currentStep === formSteps.length) {
                buildMessage(data);
                $('.tpfl-bespoke__controls-skip').hide();
            }
            setProgressBar();
        }

        prevStep.on('click', () => {
            if (currentStep === 1) {
                return;
            }
            if (currentStep === formSteps.length) {
                $('.tpfl-bespoke__controls-skip').show();
            }
            currentStep -= 1;
            formSteps.hide();
            $(`.tpfl-bespoke__field-group[data-step="${currentStep}"]`).show();
            if (currentStep === formSteps.length -1) {
                $('html, body').animate({
                    scrollTop: $('#design-your-system').offset().top
                }, 1000);
            }
            updateFormStep();
            setProgressBar();
        });

        skipToForm.on('click', () => {
            currentStep = formSteps.length
            formSteps.hide();
            $(`.tpfl-bespoke__field-group[data-step="${currentStep}"]`).show();
            $('.tpfl-bespoke__controls-skip').hide();
            buildMessage(data);
            updateFormStep();
            setProgressBar();
        });

        // if contact form validation fails, skip to form

        function getQueryParam(param) {
            var url_params = new URLSearchParams(window.location.search);
            return url_params.get(param);
        }
        var is_bespoke_and_failed = getQueryParam('form');
        if(is_bespoke_and_failed == 'scroll'){
            currentStep = formSteps.length
            formSteps.hide();
            $(`.tpfl-bespoke__field-group[data-step="${currentStep}"]`).show();
            $('.tpfl-bespoke__controls-skip').hide();
            buildMessage(data);
            updateFormStep();
            setProgressBar();
        }    

        options.on('click', (e) => {
            const target = $(e.currentTarget);
            const formGroup = target.closest('.tpfl-bespoke__field-group');
            if (data && data[formGroup.data('step')]) {
                delete data[formGroup.data('step')];
            }
            data[formGroup.data('step')] = {
                message: formGroup.data('message'),
                name: formGroup.data('name'),
                value: target.data('value')
            };
            formGroup.find('.option').removeClass('active');
            target.toggleClass('active');
            nextStep();
        });
    }

})(jQuery); 